export default "__VITE_ASSET__DkmvcgfZ__"